/**
 * 保证金相关Ticker
 */

import { atom } from "recoil";
import {
  selectorFamilyWithoutCache as selectorFamily,
  selectorWithoutCache as selector,
} from "util/RecoilWithoutCache";
import { MixContractTokenInfo } from "../entity";
import { CurrentBusinessLineState } from "./Base";
import { BusinessLineToQuoteToken } from "../../constants/base";

/**
 * 生成默认保证金ticker，还是需要indexPrice=1兜底
 */
export function createDefaultTokenTicker(): MixContractTokenInfo {
  return {
    baseTokenId: "",
    businessType: "",
    indexPrice: "1",
    key: "",
    quoteTokenId: "",
    version: 0,
  };
}

function isValidToken(token: MixContractTokenInfo): boolean {
  return Boolean(token.baseTokenId && token.quoteTokenId && token.key);
}

/**
 * 混合合约 所有保证金价格信息
 */
export const MixContractTokenState = atom<MixContractTokenInfo[]>({
  key: "mix-ct-token-state",
  default: [],
});

export const MixContractAllTokensSelector = selector<MixContractTokenInfo[]>({
  key: "all-token-selector-public",
  get: ({ get }) => {
    return get(MixContractTokenState).filter((token) => isValidToken(token));
  },
  set: ({ get, set }, tokens: MixContractTokenInfo[]) => {
    set(MixContractTokenState, tokens);
  },
});

export const getTokenPriceByTokenId = selectorFamily({
  key: "token-price-getter",
  get:
    (tokenId: string) =>
    ({ get }) => {
      const businessLine = get(CurrentBusinessLineState);
      const tokenTickers = get(MixContractTokenState);

      const result = tokenTickers.find(
        (ticker) =>
          ticker.baseTokenId === tokenId &&
          ticker.quoteTokenId === BusinessLineToQuoteToken[businessLine]
      );

      return result || createDefaultTokenTicker();
    },
});

export const getTokenPriceByTokenIdAndKey = selectorFamily<
  MixContractTokenInfo[keyof MixContractTokenInfo],
  [string, keyof MixContractTokenInfo]
>({
  key: "token-price-key-getter",
  get:
    ([tokenId, key]: [string, keyof MixContractTokenInfo]) =>
    ({ get }) => {
      const businessLine = get(CurrentBusinessLineState);
      const tokenTickers = get(MixContractTokenState);

      const result = tokenTickers.find(
        (ticker) =>
          ticker.baseTokenId === tokenId &&
          ticker.quoteTokenId === BusinessLineToQuoteToken[businessLine]
      );

      return (result || createDefaultTokenTicker())[key];
    },
});

/**
 * 当前业务线保证金币价
 */
export const CurrentBusinessTokenTickers = selector({
  key: "current-business-token-tickers",
  get: ({ get }) => {
    const tokenTickers = get(MixContractTokenState);
    const businessLine = get(CurrentBusinessLineState);

    return tokenTickers.filter((ticker) => {
      return ticker.quoteTokenId === BusinessLineToQuoteToken[businessLine];
    });
  },
});
export const CurrentBusinessTokenTickersMapSelector = selector<
  Map<string, string>
>({
  key: "current-business-token-map-selector",
  get: ({ get }) => {
    const tokenTickers = get(MixContractTokenState);
    const businessLine = get(CurrentBusinessLineState);
    const map = new Map();

    let _get = map.get;

    map.get = function (key: string) {
      const result = tokenTickers.find(
        (ticker) =>
          ticker.baseTokenId === key &&
          ticker.quoteTokenId === BusinessLineToQuoteToken[businessLine]
      );

      return result || createDefaultTokenTicker();
    };

    return tokenTickers.reduce((map, info) => {
      map.set(info.tokenId, info);
      return map;
    }, map);
  },
});
